import { APP_CONST } from "./constants";

export const apiHost = window.RUNTIME_API_HOST
  ? window.RUNTIME_API_HOST
  : APP_CONST.apiHost;

// confguration object with fluke connect pre-production base url
export const config = {
  flukeIotApiUrl: apiHost + "/api/iot",
  apiUrl: apiHost + "/api/fc",
  sopApiUrl: apiHost + "/api/sop",
  apiMeasUrl: apiHost + "/api/meas",
  flukeBlueZoneApiUrl: "https://bluzone.io/portal/papis/v1",
  webSocketConn: apiHost + "/wsApi",
  webSocketConnFC: apiHost + "/wsApiFC",
  s3Proxy: apiHost + "/s3Proxy",
  s3FileUploadProxy: apiHost + "/s3FileUploadProxy",
  reportingUrl: apiHost + "/api/reporting",
  eloquaUrl: apiHost + "/api/eloqua"
};
